<template>
  <div>
    <div style="text-align: center;font-weight: bold;font-size: 25px;margin-top: 60px">部署资料上传</div>
    <div style="width: 45%;margin: 30px auto" v-loading="loading">
      <div class="child-div2">
        <div class="content">
          <div class="text">
            <div style="color: rgb(87, 96, 109);font-size: 16px">您已注册完成供应商：{{supplierName}}</div>
            <div style="color: rgb(76, 86, 100);font-size: 16px;margin-top: 4px">在开始使用前，请先完成以下部署资料的上传</div>
          </div>
        </div>
      </div>
      <div class="child-div">
        <div class="content">
          <div class="text">
            <p style="font-weight: bold;font-size: 17px">品牌产品</p>
            <p style="color: rgb(142, 135, 123)">请先下载模板，填写完成后上传更新</p>
          </div>
          <div style="display: flex; justify-content: space-between; align-items: center">
            <div style="color: rgb(0, 176, 240);margin-right: 10px" v-if="brands === 1">上传完成</div>
            <el-button class="button" icon="el-icon-upload" style="background-color: rgb(255, 143, 31)" size="medium" @click="openProductInfoUpdateDialog">{{ brands === 0 ? '信息上传':'信息修改' }}</el-button>
          </div>
        </div>
      </div>
      <div class="child-div">
        <div class="content">
          <div class="text">
            <p style="font-weight: bold;font-size: 17px">导购名单</p>
            <p style="color: rgb(142, 135, 123)">请先下载模板，填写完成后上传更新</p>
          </div>
          <div v-if="sales === -1" style="display: flex;align-items: center;color: rgb(221, 221, 221);font-size: 16px;margin-right: 20px">
            <div>等待中</div>
          </div>
          <div v-else style="display: flex; justify-content: space-between; align-items: center">
            <div style="color: rgb(0, 176, 240);margin-right: 10px" v-if="sales !== 0">{{ sales === 1 ? '上传完成':'已跳过' }}</div>
            <div v-if="sales === 0" style="width: 150px">
              <el-button class="button2" icon="el-icon-upload" style="background-color: rgb(255, 143, 31)" @click="saleDialog.centerDialogVisible = true" size="medium">信息上传</el-button>
              <i class="el-icon-arrow-right" style="color: #EF6C00;cursor: pointer;" @click="jump">跳过</i>
            </div>
            <el-button v-else class="button" icon="el-icon-upload" style="background-color: rgb(255, 143, 31)" @click="saleDialog.centerDialogVisible = true" size="medium">{{ sales === 0 ? '信息上传':'继续补充' }}</el-button>
          </div>
        </div>
      </div>
      <div class="child-div">
        <div class="content">
          <div class="text">
            <p style="font-weight: bold;font-size: 17px">提成规则</p>
            <p style="color: rgb(142, 135, 123)">请先下载模板，填写完成后上传更新</p>
          </div>
          <div v-if="packages === -1" style="display: flex;align-items: center;color: rgb(221, 221, 221);font-size: 16px;margin-right: 20px">
            <div>等待中</div>
          </div>
          <div v-else style="display: flex; justify-content: space-between; align-items: center">
            <div style="color: rgb(0, 176, 240);margin-right: 10px" v-show="packages === 1">上传完成</div>
            <el-button class="button" icon="el-icon-upload" style="background-color: rgb(255, 143, 31)" @click="openUploadPackage" size="medium">{{ packages === 0 ? '信息上传':'继续补充' }}</el-button>
          </div>
        </div>
      </div>

      <div style="display: flex; flex-direction: column; align-items: center;">
        <el-button
          class="button"
          :style="{width: '120px', height: '40px', margin: '50px auto 10px',backgroundColor: packages !== 1?'':'rgb(255, 143, 31)',color: packages !== 1?'':'white'}"
          :disabled="packages !== 1"
          @click="successUpload"
          size="medium"
        >
          上传完成
        </el-button>
        <div v-if="supplierType === '2'" style="color: rgb(142, 135, 123);cursor: pointer;" @click="toConsole">进入数据中心</div>
      </div>
    </div>
    <el-dialog
      center
      title="产品信息管理"
      width="1000px"
      :visible.sync="brandDialog.productInfoUpdateDialogVisible"
      :before-close="closeProductInfoUpdateDialogInnerDialog"
    >
      <div>
        <div class="dialog-title">
          <div class="title-line"/>
          <div class="bold-title">品牌系列管理</div>
        </div>

        <div class="tips">1.若有新品牌/系列，请提前在下方添加</div>

        <el-table
          :data="brandDialog.table"
          height="250"
          border
          style="width: 100%; margin: 20px 0;">
          <el-table-column
            prop="date"
            width="150px"
            :width="flexColumnWidth('name')"
            header-align="center"
          >
            <template slot="header" slot-scope="scope">
              <div class="flex-row">
                <div>品牌</div>
                <el-button class="button-new-tag-mini" size="small"
                           @click="openProductInfoUpdateDialogInnerDialog(true, 'parentBrand')">
                  +添加
                </el-button>
              </div>
            </template>

            <template slot-scope="scope">
              <el-tag
                class="tag-parent-brand"
                size="medium">
                {{ scope.row.name }}
              </el-tag>
            </template>
          </el-table-column>

          <el-table-column
            prop="name"
            label="相关系列"
            header-align="center"
          >
            <template slot-scope="scope">
              <div class="flex-row" style="justify-content: left; white-space:normal">
                <el-tag
                  class="tag-brand"
                  size="medium"
                  :key="brand"
                  v-for="brand in scope.row.children">
                  {{ brand.name }}
                </el-tag>

                <el-button class="button-new-tag" size="small" v-if="scope.row.id"
                           @click="openProductInfoUpdateDialogInnerDialog(true, 'brandName', scope.$index)">+添加系列
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>

        <div>
          <div class="dialog-title">
            <div class="title-line"/>
            <div class="bold-title">产品信息批量修改</div>
          </div>

          <div class="tips">
            1.模板中信息请完整填写，上传产品信息将立即生效。
          </div>
        </div>
      </div>

      <el-dialog
        width="30%"
        :title="'添加' + (brandDialog.innerDialog.type === 'parentBrand' ? '品牌' : '系列')"
        center
        :visible.sync="brandDialog.innerDialog.innerDialogVisible"
        v-loading="loading"
        append-to-body>
        <div>
          <el-input v-if="brandDialog.innerDialog.type === 'parentBrand'" ref="productInput"
                    v-model="brandDialog.innerDialog.inputParentBrandTagValue" placeholder="请输入品牌名"></el-input>

          <el-input v-else-if="brandDialog.innerDialog.type === 'brandName'" ref="productInput"
                    v-model="brandDialog.innerDialog.inputBrandNameValue"
                    placeholder="请输入系列名"></el-input>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="openProductInfoUpdateDialogInnerDialog(false, '')">取消</el-button>
          <el-button type="primary"
                     @click="brandDialog.innerDialog.type === 'parentBrand' ? addParentBrand() : addBrandName()">确认添加
          </el-button>
        </div>
      </el-dialog>

      <div slot="footer" class="dialog-footer">
        <div style="display: flex">
          <el-button class="plain-btn" :loading="downloadLoading"
                     @click="downloadProductTemplate()">下载产品清单(模板)
          </el-button>

          <el-button class="orangev-btn" :loading="uploadLoading"
                     @click="uploadProductTemplate()">上传产品清单
            <input type="file" ref="uploadProductLabel" v-show="false" accept=".xls,.xlsx" @change="putProductExcel"/>
          </el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      title="批量预注册"
      :visible.sync="saleDialog.centerDialogVisible"
      width="30%"
      center>
      <h1>批量预注册:</h1>
      <span>1、请先下载预注册模版</span>
      <br>
      <span>2、下载模板后，在模板基础上填写，勿新增或删除字段，每个空格须填写完整。</span>
      <br>
      <span>3、点击上传填写完成的预注册模版</span>
      <span slot="footer" class="dialog-footer">
          <el-button style="color: #FF6633; border-color: #FF6633; " :loading="downloadLoading"
                     @click="importSaleLabel">下载预注册模板
          </el-button>
          <el-button style="color: white; border-color: #FF6633; background-color: #FF6633" :loading="uploadLoading"   @click="$refs.uploadSaleResult.click()" >上传预注册模板</el-button>
          <input type="file" ref="uploadSaleResult" v-show="false" accept=".xls,.xlsx" @change="upLoadSaleExcel"/>
      </span>
    </el-dialog>

    <el-dialog
      :visible.sync="uploadProductPackageDialog.visible"
      width="500px"
      class="uploadDialog"
      :close-on-click-modal="false"
      center>
      <div slot="title" class="dialog-title">产品提成规则上传</div>
      <div class="content">
        <div style="text-align: center;font-size: 17px;margin-top: 20px">1、请先下载产品提成规则上传模版</div>
        <div style="text-align: center;margin-top: 20px">
          <el-button :loading="downloadLoading" type="primary" size="small"  @click="downloadPackageTemplate">下载模板</el-button>
        </div>
        <div style="text-align: center;font-size: 17px;margin-top: 20px">2、请设置产品提成规则生效时间</div>
        <div style="text-align: center;margin-top: 20px">
          <el-date-picker
            type="daterange"
            style="margin: 0 auto"
            v-model="uploadProductPackageDialog.rang"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            range-separator="-"
            unlink-panels
            :editable="false"
            :clearable="false"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </div>
        <div style="text-align: center;font-size: 17px;margin-top: 20px">3、点击上传填写完成的产品提成规则</div>
        <div style="margin-top: 20px;text-align: center;">
          <el-upload
            :disabled="uploadProductPackageDialog.loading"
            class="upload"
            ref="uploadBatch"
            action="#"
            accept=".xls,.xlsx"
            :show-file-list="false"
            :http-request="(file) => uploadProductPackageDialog.file = file.file">
            <div slot="trigger" class="description">
              <i class="el-icon-plus" style="padding: 10px 20px; color: #00000066; font-size: 20px"></i>
            </div>
          </el-upload>
          <div style="margin-top: 10px" v-if="uploadProductPackageDialog.file">{{uploadProductPackageDialog.file.name}}</div>
        </div>
        <div style="text-align: center; margin-top: 50px;">
          <el-button :loading="uploadLoading" type="primary" :disabled="uploadProductPackageDialog.file === null || this.uploadProductPackageDialog.rang < 2" @click="uploadPackageTemplate">确定上传</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {addBrandName, addParentBrand, downloadTemplate, queryProduct, uploadTemplate} from "@/api/ProductManagement";
import {querySupplierData, supplierDataSaleJump} from "@/api/login";
import {importLabelPre, putExcel} from "@/api/ReportDetailPagePurchase";
import {downloadPackageTemplate, uploadPackageTemplate} from "@/api/package";

export default {
  data () {
    return {
      brands: 0,
      sales: -1,
      packages: -1,
      supplierId: '',
      supplierName: '',
      supplierType: 2,
      uploadLoading: false,
      downloadLoading: false,
      loading: false,
      token: '',
      //产品信息管理
      brandDialog: {
        table: [],
        //产品信息管理dialog开关
        productInfoUpdateDialogVisible: false,
        //内层嵌套dialog 添加品牌/系列dialog
        innerDialog: {
          //开关
          innerDialogVisible: false,
          //parentBrand, brandName
          type: '',
          //品牌信息
          inputParentBrandTagValue: '',
          //系列信息
          inputBrandNameValue: ''
        }
      },
      saleDialog: {
        centerDialogVisible: false
      },
      uploadProductPackageDialog: {
        visible: false,
        file: null,
        rang: []
      }
    }
  },
  created() {
    this.token = localStorage.getItem('token')
    this.supplierId = localStorage.getItem('supplierId')
    this.querySupplierData()
  },
  methods: {
    querySupplierData() {
      this.loading = true
      querySupplierData(this.token, this.supplierId).then(({data}) => {
        const {packageCount, productCount, saleCount, supplierName, supplierType, jump} = data.data
        this.supplierName = supplierName
        this.supplierType = supplierType
        if (productCount > 0) {
          this.brands = 1
          this.sales = 0
        }
        if (saleCount > 0) {
          this.sales = 1
          this.packages = 0
        } else if (jump) {
          this.sales = 2
        }
        if (this.sales === 2) {
          this.packages = 0
        }
        if (packageCount > 0) {
          this.packages = 1
        }
      }).finally(() => {
        this.loading = false
      })
    },
    //打开产品信息管理dialog
    openProductInfoUpdateDialog() {
      this.closeProductInfoUpdateDialogInnerDialog();
      this.brandDialog.productInfoUpdateDialogVisible = true;
      this.loading = true
      queryProduct(this.token, this.supplierId).then(({data}) => {
        this.brandDialog.table = data.data;
      }).finally(() => this.loading = false)
    },
    //关闭产品信息管理dialog
    closeProductInfoUpdateDialogInnerDialog() {
      this.brandDialog = {
        table: [],
        productInfoUpdateDialogVisible: false,
        innerDialog: {
          innerDialogVisible: false,
          type: '',
          inputParentBrandTagValue: '',
          inputBrandNameValue: ''
        }
      }
    },
    uploadProductTemplate() {
      this.$refs.uploadProductLabel.click()
    },
    downloadProductTemplate() {
      this.downloadLoading = true;
      downloadTemplate(this.token, {supplierId: this.supplierId, supplierName: this.supplierName}).then(res => {
        let blob = new Blob([res.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'})
        let url = window.URL.createObjectURL(blob)
        let link = document.createElement('a')
        link.href = url
        let fileName = decodeURI(res.headers['filename'])
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
      }).finally(() => this.downloadLoading = false)

    },
    putProductExcel() {
      this.uploadLoading = true;
      let inputDOM = this.$refs.uploadProductLabel
      let file = inputDOM.files[0]
      let formData = new FormData();
      formData.append("file", file)
      uploadTemplate(this.token, formData, this.supplierId).then(r => {
        let {data} = r
        if (data.code === 200) {
          this.$notify.success({
            title: '成功',
            message: '上传成功',
            position: 'bottom-right'
          })
          this.brandDialog.productInfoUpdateDialogVisible = false
          this.querySupplierData()
        } else if (data.code === 0) {
          this.$notify.error({
            title: '错误',
            message: data.msg,
            position: 'bottom-right'
          })
        }
      }).catch(error => {
        let status = error.response.status;
        if (status === 500) {
          this.$notify.error({
            title: '错误',
            message: '上传失败，请联系管理员',
            position: 'bottom-right'
          })
        }
      }).finally(() => {
        this.uploadLoading = false;
        this.$refs.uploadProductLabel.value = ''
      })
    },
    //打开产品信息管理dialog内部dialog(添加品牌/系列dialog)
    openProductInfoUpdateDialogInnerDialog(status, type, index) {
      this.brandDialog.innerDialog.innerDialogVisible = status;
      this.brandDialog.innerDialog.type = type;
      this.brandDialog.innerDialog.inputParentBrandTagValue = '';
      this.brandDialog.innerDialog.inputBrandNameValue = '';

      if (index != null) {
        this.brandDialog.innerDialog.inputParentBrandTagValue = this.brandDialog.table[index].id;
      }

      if (status) {
        this.$nextTick(() => {
          this.$refs.productInput.focus()
        })
      }
    },
    //添加品牌
    addParentBrand() {
      //添加品牌信息
      if (!this.brandDialog.innerDialog.inputParentBrandTagValue || !this.brandDialog.innerDialog.inputParentBrandTagValue.length)
        return this.$message.error("请输入品牌名称");

      const param = {
        supplierId: this.supplierId,
        parentBrand: this.brandDialog.innerDialog.inputParentBrandTagValue
      }

      addParentBrand(this.token, param).then(res => {
        if (res.data.code === 200) {
          this.openProductInfoUpdateDialog();
          this.$message.success("添加品牌成功");
        } else {
          this.$message.error("添加品牌失败")
        }
      }).catch(() => {
        this.$message.error("添加品牌失败")
      }).finally(() => {
      })
    },
    //添加系列
    addBrandName() {
      if (!this.brandDialog.innerDialog.inputParentBrandTagValue || !this.brandDialog.innerDialog.inputParentBrandTagValue.length) {
        return this.$message.error("请选择品牌");
      }
      if (!this.brandDialog.innerDialog.inputBrandNameValue || !this.brandDialog.innerDialog.inputBrandNameValue.length) {
        return this.$message.error("请输入系列名称");
      }
      const param = {
        supplierId: this.supplierId,
        parentBrand: this.brandDialog.innerDialog.inputParentBrandTagValue,
        brandName: this.brandDialog.innerDialog.inputBrandNameValue,
      }
      addBrandName(this.token, param).then(res => {
        if (res.data.code === 200) {
          this.openProductInfoUpdateDialog();
          this.$message.success("添加系列成功");
        } else {
          this.$message.error("添加系列失败")
        }
      }).catch(() => {
        this.$message.error("添加系列失败")
      }).finally(() => {
      })
    },
    importSaleLabel() {
      this.downloadLoading = true
      importLabelPre(this.token, {selectedSupplierIds:[{id:this.supplierId,name:this.supplierName}]}).then(res => {
        if (res !== null) {
          this.$notify({
            type: 'success',
            message: '导出成功',
            title: '成功',
            position: 'bottom-right'
          })
          this.handleDownload(res)
          this.loading = false
        }
      }).catch(error => {
        let status = error.response.status;
        if (status === 500) {
          this.$notify({
            title: '错误',
            message: '导出错误，请及时联系管理员',
            type: 'error',
            position: 'bottom-right'
          })
        }
      }).finally(() => {
        this.downloadLoading = false
      })
    },
    upLoadSaleExcel() {
      let inputDOM = this.$refs.uploadSaleResult
      let file = inputDOM.files[0]
      let formData = new FormData();
      formData.append("file", file)
      this.uploadLoading = true
      putExcel(this.token, this.supplierId, formData).then(r => {
        let {data} = r
        if (data.code === 200) {
          this.$notify.success({
            title: '成功',
            message: '上传成功',
            position: 'bottom-right'
          })
          this.saleDialog.centerDialogVisible = false
          this.querySupplierData()
        } else if (data.code === 1){
          this.$alert(data.date, data.msg, {
            confirmButtonText: '确定',
            dangerouslyUseHTMLString: true
          });
        }else {
          this.$alert(data.date, data.msg, {
            dangerouslyUseHTMLString: true,
            confirmButtonText: '确定'
          });
        }
      }).catch(error => {
        let status = error.response.status;
        if (status === 500) {
          this.$notify.error({
            title: '错误',
            message: '请联系管理员',
            position: 'bottom-right'
          })
        }
      }).finally(() => {
        this.uploadLoading = false
        this.$refs.uploadSaleResult.value = ''
      })
    },
    //打开产品提成规则上传弹框
    openUploadPackage() {
      this.uploadProductPackageDialog = {
        visible: true,
        loading: false,
        file: null,
        rang: []
      }
    },
    downloadPackageTemplate() {
      this.downloadLoading = true;
      downloadPackageTemplate(this.token, this.supplierId).then(res => {
        if (res.data) {
          this.handleDownload(res)
        }
      }).finally(() => this.downloadLoading = false)
    },
    //上传规则模板
    uploadPackageTemplate() {
      if (this.uploadProductPackageDialog.rang.length < 2) {
        this.$notify.warning({
          title: '提示',
          message: '未选择提成规则生效时间',
          position: 'bottom-right'
        })
        return
      }
      let formData = new FormData()
      formData.append("file", this.uploadProductPackageDialog.file)
      formData.append("supplierId", this.supplierId)
      formData.append("startDate", this.uploadProductPackageDialog.rang[0])
      formData.append("endDate", this.uploadProductPackageDialog.rang[1])
      this.uploadLoading = true
      uploadPackageTemplate(this.token,formData).then(res => {
        if (res.data.code === 1) {
          this.$notify.error({
            title: '失败',
            message: res.data.msg,
            position: 'bottom-right'
          })
        } else {
          this.$notify.success({
            title: '成功',
            message: res.data.msg,
            position: 'bottom-right'
          })
          this.uploadProductPackageDialog.visible = false;
          this.querySupplierData()
        }
      }).finally(() => this.uploadLoading = false)
    },
    flexColumnWidth(prop) {
      const arr = this.brandDialog.table.map(x => x[prop])
      const width = (this.getMaxLength(arr) + 25);
      return (width < 120 ? 120 : width) + 'px'
    },
    /**
     * 遍历列的所有内容，获取最宽一列的宽度
     * @param arr
     */
    getMaxLength(arr) {
      return arr.reduce((acc, item) => {
        if (item) {
          const calcLen = this.getTextWidth(item)
          if (acc < calcLen) {
            acc = calcLen
          }
        }
        return acc
      }, 0)
    },
    /**
     * 使用span标签包裹内容，然后计算span的宽度 width： px
     * @param valArr
     */
    getTextWidth(str) {
      let width = 0
      const html = document.createElement('span')
      html.innerText = str
      html.className = 'getTextWidth'
      document.querySelector('body').appendChild(html)
      width = document.querySelector('.getTextWidth').offsetWidth
      document.querySelector('.getTextWidth').remove()
      return width
    },
    handleDownload (res) {
      // 创建下载的链接
      // 设置该文件的mime类型，这里对应的mime类型对应为.xlsx格式
      let blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      const fileName = decodeURI(res.headers['filename'])
      link.setAttribute('download', fileName)
      document.body.appendChild(link)
      link.click()
    },
    toConsole() {
      this.$router.push({name: 'console'})
    },
    successUpload() {
      this.$alert('恭喜您已上传完成部署资料，您可以在微信小程序通路管理助手中邀请导购签约加入，即可开始晒单。', '部署完成', {
        confirmButtonText: '前往数据中心',
        showClose: false,
        callback: action => {
          if (action === 'confirm')
              this.toConsole()
        }
      });
    },
    jump() {
      supplierDataSaleJump(this.token,this.supplierId);
      this.sales = 2
      this.packages = 0
    }
  }
}
</script>

<style scoped>
.child-div2 {
  width: 100%;
  height: 100px;
  display: flex;
  align-items: center;
  padding: 0 20px;
}
.child-div {
  width: 100%;
  height: 100px;
  border: 1px solid rgb(229, 231, 235);
  border-radius: 8px;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  padding: 0 20px;
  box-sizing: border-box;
}
.child-div .content {
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: 100%;
}

.child-div .text {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.child-div .text p {
  margin: 0
}

.child-div .button {
  background-color: #EF6C00;
  color: white;
  font-size: 15px;
  width: 150px;
}

.child-div .button2 {
  background-color: #EF6C00;
  color: white;
  font-size: 13px;
  width: 108px;
}

>>> .el-dialog__title {
  color: #ED7043;
  font-weight: 600;
  font-size: 20px;
}

.tag-brand {
  background: #F5F7FA !important;
  color: #979797 !important;;
  border-color: #C1C4CB !important;
  height: 30px;
  line-height: 28px;
}

.tag-parent-brand {
  background: #FFEFDB !important;
  color: #FF6633 !important;;
  border-color: #FF6633 !important;
  width: 100%;
  text-align: center;
  height: 30px;
  line-height: 28px;
}

.button-new-tag {
  width: 70px;
  height: 30px;
  line-height: 28px;
  padding: 0;
  border-color: #FF6633;
  color: #FF6633;
  box-sizing: border-box;
}

.button-new-tag-mini {
  width: 45px;
  height: 28px;
  line-height: 28px;
  padding: 0;
  border-color: #FF6633;
  color: #FF6633;
  box-sizing: border-box;
}

.orangev-btn {
  background-color: #FF6633;
  color: white;
  width: 100%;
}

.plain-btn {
  border-color: #FF6633;
  color: #FF6633;
  width: 100%;
}

.tips {
  color: #979797;
  font-size: 14px;
  line-height: 25px;
}

.flex-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  justify-content: center;
  flex-wrap: wrap;
}

.dialog-title {
  display: flex;
  flex-direction: row;
  margin-bottom: 20px;
}

.dialog-title .title-line {
  width: 5px;
  background: #ED7043;
  margin-right: 10px;
}

.dialog-title .bold-title {
  font-weight: 600;
  color: #000000;
  font-size: 18px;
}

.uploadDialog .dialog-title {
  color: #ED7043;
  font-size: 24px;
  font-weight: 600;
  text-align: center;
  margin-bottom: 0;
}
.uploadDialog .description {
  color: #979797;
  background-color: #F3F3F3;
  padding: 10px;
  border-radius: 10px;
  text-align: left;
  line-height: 23px;
}
</style>
